import src from "IMAGE";
export default { src, width: 248, height: 74, blurWidth: 0, blurHeight: 0};
